import React, { useState, useEffect, useRef, Fragment } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import { classNames, renderCheckboxterms } from "@basecomponent";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import LocaleStrings from "@language";
import { Dialog, Transition } from "@headlessui/react";
import { ArrowLeftIcon } from "@heroicons/react/solid";
import { XIcon } from "@heroicons/react/outline";
import {
  openRechargeModal,
  makePayment,
  addOrder,
  createMerchant,
} from "@transactionaction";
import coin from "../../../assets/image/coin.png";
import toast from "react-hot-toast";

const Recharge = (props) => {
  const navigate = useNavigate();
  var { session, openRecharge, handleSubmit, eventData, conversionRate } =
    props;
  var [loading, setLoading] = useState(false);
  const close = () => {
    props.openRechargeModal({ showModal: false, obj: {} });
  };

  const close1 = () => {};
  const onSubmitForm = (values) => {
    setLoading(true);
    let tikwash_key = "a909ee509321c6e2f8b154a396acd3db9b190bd7";
    // console.log("obj", openRecharge?.obj);
    // debugger;
    if (eventData.api_key) {
      let payValues = {};
      payValues.requesttype = "init";
      payValues.tokencost = openRecharge?.obj?.tokencost;
      payValues.tokenname = openRecharge?.obj?.tokenname;
      payValues.caller = "portal";
      //payValues.merchantid = eventData.merchantid;
      payValues.companyid = eventData.useridfk;
      // console.log("payValues", payValues);

      props.makePayment(session, payValues, (callback) => {
        //console.log("callback", callback);
        if (callback.success === 1 && callback?.result?.data?.payment_url) {
          let payment_url = callback.result.data.payment_url;
          let order_id = callback.result.data.order_id;
          values.requesttype = "updateTransaction";
          values.transactiontype = `purchase`;
          values.useridfk = session.userid;
          values.companyidfk = eventData.useridfk;
          values.transactioncode = order_id;
          values.description = openRecharge?.obj?.description
            ? openRecharge?.obj?.description
            : `Purchase ${openRecharge?.obj?.tokenname}`;
          values.transactionpaidtoken = parseInt(
            openRecharge?.obj?.paidtokenorg
          );
          values.transactionfreetoken = parseInt(
            openRecharge?.obj?.freetokenorg
          );
          values.transactionamount = openRecharge?.obj?.tokencost;
          values.validity = openRecharge?.obj?.tokenvalidity;
          values.status = "pending";
          values.action = "insert";
          values.paymode = "";
          values.source = eventData.api_key == tikwash_key ? "" : "web";
          values.transactionid = null;
          if (openRecharge?.obj?.tokenid) {
            values.tokenpackidfk = openRecharge?.obj?.tokenid;
          }
          // console.log("values", values);
          // debugger;
          props.addOrder(session, values, (response) => {
            // console.log("response", response);
            // debugger;
            if (response.success === 1) {
              setLoading(false);
              close();
              window.location.href = payment_url + "&methods=all";
            } else {
              setLoading(false);
              close();
              toast.error(LocaleStrings.common_fail_message);
            }
          });
        } else {
          setLoading(false);
          close();
          toast.error(LocaleStrings.payment_server_message);
        }
      });
    } else {
      setLoading(false);
      close();
      toast.error(LocaleStrings.common_fail_message);
    }
  };

  //console.log("eventData", eventData);
  return (
    <>
      <Transition.Root
        show={openRecharge?.showModal ? true : false}
        as={Fragment}
      >
        <Dialog
          as="div"
          className="fixed z-10 inset-0 overflow-y-auto"
          onClose={close1}
        >
          <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            {/* This element is to trick the browser into centering the modal contents. */}
            <span
              className="hidden sm:inline-block sm:align-middle sm:h-screen"
              aria-hidden="true"
            >
              &#8203;
            </span>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className="inline-block align-bottom bg-white rounded-lg pt-4 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full">
                <div className="h-full flex flex-col">
                  <div className="px-5 grid grid-cols-2 gap-1 border-b pb-3">
                    <div className="text-left text-primary font-normal text-xl">
                      {LocaleStrings.make_payment_heading}
                    </div>
                    <div
                      className="text-right text-link font-normal text-base cursor-pointer"
                      onClick={() => close()}
                    >
                      <button className="theme-icon-button-xs" onClick={close}>
                        <XIcon className="h-5 w-5" aria-hidden="true" />
                      </button>
                    </div>
                  </div>
                  <form onSubmit={handleSubmit(onSubmitForm)}>
                    <div className="max-w-lg mx-auto p-4 h-full">
                      <div className="grid grid-cols-3">
                        <div className="flex items-center justify-start">
                          <img src={coin} className="w-7" />
                        </div>
                        <div className="">
                          <div>{openRecharge?.obj?.tokenname}</div>
                          <div>
                            &euro;
                            {openRecharge?.obj?.paidtoken
                              .toFixed(2)
                              .replace(".", ",")}
                            {openRecharge?.obj?.freetoken
                              ? "+ \u20AC" +
                                openRecharge?.obj?.freetoken
                                  .toFixed(2)
                                  .replace(".", ",") +
                                LocaleStrings.free
                              : ""}
                          </div>
                          {openRecharge?.obj?.tokenvalidity < 18250 ? (
                            <div style={{ color: "#e25052", opacity: 0.75 }}>
                              valid for {openRecharge?.obj?.tokenvalidity}{" "}
                              day(s)
                            </div>
                          ) : (
                            ""
                          )}
                        </div>
                        <div className="flex items-center justify-center">
                          &euro;
                          {parseFloat(openRecharge?.obj?.tokencost)
                            .toFixed(2)
                            .replace(".", ",")}
                        </div>
                      </div>
                      <div className="mt-6 flex items-center gap-2">
                        <Field
                          name="termsncondi"
                          label=""
                          component={renderCheckboxterms}
                          mandatory="true"
                        />
                      </div>
                      <div className="flex items-center justify-center mt-4">
                        <button
                          type="submit"
                          className="bg-managebutton rounded py-2 px-5 w-full flex items-center justify-center"
                        >
                          {loading ? (
                            <svg
                              className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <circle
                                className="opacity-25"
                                cx="12"
                                cy="12"
                                r="10"
                                stroke="currentColor"
                                stroke-width="4"
                              ></circle>
                              <path
                                className="opacity-75"
                                fill="currentColor"
                                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              ></path>
                            </svg>
                          ) : (
                            ""
                          )}
                          {LocaleStrings.make_payment_btn}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

const validate = (values) => {
  var errors = {};
  if (!values.termsncondi) {
    errors.termsncondi = LocaleStrings.check_terms;
  }
  return errors;
};

const mapStateToProps = (state) => {
  return {
    session: state.session,
    openRecharge: state.openRecharge,
    eventData: state.eventData,
    conversionRate: state.conversionRate,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { openRechargeModal, makePayment, addOrder, createMerchant },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "RechargeForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Recharge)
);
